export const HOME = "/";
export const SEARCH = "/search";
export const SIGN_UP = "/sign-up";
export const LOGIN = "/login";
export const RESET_PASSWORD = "/reset-password";
export const ACCOUNT = "/account";
export const CHANGE_PASSWORD = "/change-password";
export const PROFILE = "/profile";
export const USER_BY_ID = "/users/:id";
export const MY_SONGS = "/my-songs";
export const MY_FAVOURITE_SONGS = "/my-favourite-songs";
export const PLAYLIST_BY_ID = "/playlist/:id";
export const MY_PLAYLISTS = "/my-playlists";
export const FOLLOWING_PLAYLISTS = "/following-playlists";
export const USER_SONGS = "/user-songs";
export const USER_FAVOURITE_SONGS = "/user-favourite-songs";
export const USER_PLAYLISTS = "/user-playlists";
export const USER_FOLLOWING_PLAYLISTS = "/user-following-playlists";
export const GENRE_BY_ID = "/genre/:id";
export const FOLLOWING_USERS = "/users/:id/following";
export const FOLLOWED_USERS = "/users/:id/followed";
